import { API } from "@/main";

const state = {
  selectedMaterial: {
    sm_family_id: undefined,
    sm_reference: "",
    sm_description: "",
    sm_barcode: undefined,
    sm_manufacturer: undefined,
    sm_vendor: undefined,
    sm_unit_price: undefined,
    sm_labor_price: undefined,
    // sm_applicationType: [],
    sm_never_diminishing: false,
    sm_obsolete: false
  },
  selectedMaterialList: [{}],

  materials: {
    families: [
      {
        id: "cl",
        label: "Closure"
      },
      {
        id: "ca",
        label: "Cable"
      },
      {
        id: "sp",
        label: "Splitter"
      }
    ],
    imports: [
      {
        upload_date: new Date(2019, 10, 4),
        material_family: "cl",
        file: "ProjectA_Stock.xls",
        step: "",
        status: "processing"
      },
      {
        upload_date: new Date(2019, 10, 3),
        material_family: "ca",
        file: "ProjectX_Stock.csv",
        step: "save_temporary_table",
        status: "success"
      },
      {
        upload_date: new Date(2019, 10, 2),
        material_family: "cl",
        file: "ProjectY_Stock.csv",
        step: "import_to_database",
        status: "success"
      },
      {
        upload_date: new Date(2019, 10, 1),
        material_family: "ca",
        file: "ProjectZ_Stock.csv",
        step: "",
        status: "fail"
      }
    ],
    cable: [],
    cabinet: [],
    splitter: [],

    reports: {
      types: [
        { id: "a", label: "Materials" },
        { id: "b", label: "Stock On Hand" },
        { id: "c", label: "Serial Numbers" },
        { id: "d", label: "Batch Numbers" },
        { id: "e", label: "Material Suppliers" },
        { id: "f", label: "Inventory Details" },
        { id: "g", label: "Material Attributes" },
        { id: "h", label: "Material Pricing" }
      ],
      exported: [
        {
          exportDate: new Date(2019, 10, 1),
          reportTypeID: "a",
          file_url_public: "",
          status: "success"
        }
      ]
    }
  }
};

const getters = {
  getSelectedMaterial: state => state.selectedMaterial,
  getSelectedMaterialList: state => state.selectedMaterialList,

  getMaterialsImportsList: state => state.materials.imports,
  getMaterialFamilies: state => state.materials.families,
  getMaterialReportTypes: state => state.materials.reports.types,
  getMaterialExportedReportsList: state => state.materials.reports.exported
};

const mutations = {
  SET_SELECTED_MATERIAL(state, data) {
    state.selectedMaterial = data;
  },
  UPDATE_SELECTED_MATERIAL_LIST(state, data) {
    state.selectedMaterialList = data;
  },

  UPLOAD_MATERIALS_FILE(state, data) {
    state.materials.imports.unshift(data);
  },
  CREATE_NEW_MATERIAL(state, material) {
    let materialFamily = state.materials.families.find(
      family => family.id === material.familyID
    );
    state.materials[materialFamily.label].push(material);
  },
  UPDATE_MATERIAL_LIST(state, materialList) {
    let materialFamily = state.materials.families.find(
      family => family.id === materialList[0]
    );
    state.materials[materialFamily.label] = materialList[1];
  },
  UPDATE_MATERIAL_ITEM(state, updatedMaterial) {
    let materialFamily = state.materials.families.find(
      family => family.id === updatedMaterial.familyID
    );
    let materialIndex = state.materials[materialFamily.label].findIndex(
      oldMaterial => oldMaterial.clientRef === updatedMaterial.clientRef
    );
    state.materials[materialFamily.label][materialIndex] = updatedMaterial;
  },
  DELETE_MATERIAL_ITEM(state, material) {
    let materialFamily = state.materials.families.find(
      family => family.id === material.familyID
    );
    let materialIndex = state.materials[materialFamily.label].findIndex(
      materialItem => materialItem.clientRef === material.clientRef
    );
    state.materials[materialFamily.label].splice(materialIndex, 1);
  },
  EXPORT_MATERIALS_REPORT(state, data) {
    state.materials.reports.exported.unshift(data);
  }
};

const actions = {
  SET_SELECTED_MATERIAL({ commit }, material) {
    commit("SET_SELECTED_MATERIAL", material);
  },

  fetchStockMaterialsList({ commit }, queryParameters) {
    return new Promise((resolve, reject) => {
      API.materials.getAll(
        queryParameters,
        result => {
          resolve(result.data.data);
          commit("UPDATE_SELECTED_MATERIAL_LIST", result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  fetchStockMaterialsListObject({ commit }, queryParameters) {
    return new Promise((resolve, reject) => {
      API.materials.getAll(
        queryParameters,
        result => {
          resolve(result.data);
          commit("UPDATE_SELECTED_MATERIAL_LIST", result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  downloadAll({ commit }) {
    return new Promise((resolve, reject) => {
      API.materials.downloadAll(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  importMaterialFamilies({ commit }, dataToSend) {
    return new Promise((resolve, reject) => {
      API.materials.importMaterialFamilies(
        dataToSend,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  GET_STOCK_MATERIAL({ commit }, queryParameters) {
    return new Promise((resolve, reject) => {
      API.materials.getByUUID(
        queryParameters.uuid,
        queryParameters.append,
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  CREATE_NEW_MATERIAL({ commit }, material) {
    return new Promise((resolve, reject) => {
      API.materials.create(
        material,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  UPDATE_SELECTED_MATERIAL({ commit }, material) {
    return new Promise((resolve, reject) => {
      API.materials.update(
        material,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  DELETE_SELECTED_MATERIAL({ commit }, materialUuid) {
    return new Promise((resolve, reject) => {
      API.materials.delete(
        materialUuid,
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  UPDATE_MATERIAL_ITEM({ commit }, material) {
    return new Promise((resolve, reject) => {
      API.materials.update(
        material,
        result => {
          resolve(result);
          commit("UPDATE_MATERIAL_ITEM", material);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  DELETE_MATERIAL_ITEM({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.materials.delete(
        uuid,
        result => {
          resolve(result);
          commit("DELETE_MATERIAL_ITEM", uuid);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  DELETE_MATERIAL_ITEMS({ commit }, uuid) {
    return new Promise((resolve, reject) => {
      API.materials.deleteMultiple(
        uuid,
        result => {
          resolve(result);
          commit("DELETE_MATERIAL_ITEM", uuid);
        },
        error => {
          reject(error);
        }
      );
    });
  },

  UPDATE_MATERIAL_LIST({ commit }, data) {
    commit("UPDATE_MATERIAL_LIST", data);
  },

  UPLOAD_MATERIALS_FILE({ commit }, data) {
    commit("UPLOAD_MATERIALS_FILE", data);
    if (data.file.includes("cable")) {
      let importedCables = [
        {
          clientRef: "MFOA20000",
          vendorRef: "20000",
          description: "12 FO G.657A2 conduite INT/EXT modulo 6 gaine noire",
          familyID: "ca",
          quantity: 100,
          unit: "m",
          neverDiminishing: true,
          obsolete: true,
          barcode: undefined,
          applicationType: [],
          unitPrice: undefined,
          laborPrice: undefined,
          manufacturer: undefined,
          vendor: undefined,
          dimensions: { diameter: undefined, maxLength: undefined }
        },
        {
          clientRef: "MFOA20001",
          vendorRef: "20001",
          description: "24 FO G.657A2 conduite modulo 6",
          familyID: "ca",
          quantity: 540,
          unit: "m",
          neverDiminishing: true,
          obsolete: false,
          barcode: undefined,
          applicationType: [],
          unitPrice: undefined,
          laborPrice: undefined,
          manufacturer: undefined,
          vendor: undefined,
          dimensions: { diameter: undefined, maxLength: undefined }
        },
        {
          clientRef: "MFOA20002",
          vendorRef: "MFOA20002",
          description: "36 FO G.657A2 conduite modulo 6",
          familyID: "ca",
          quantity: 3500,
          unit: "m",
          neverDiminishing: true,
          obsolete: false,
          barcode: undefined,
          applicationType: [],
          unitPrice: undefined,
          laborPrice: undefined,
          manufacturer: undefined,
          vendor: undefined,
          dimensions: { diameter: undefined, maxLength: undefined }
        },
        {
          clientRef: "MFOA20003",
          vendorRef: "MFOA20003",
          description: "48 FO G.657A2 conduite modulo 6",
          familyID: "ca",
          quantity: 50,
          unit: "m",
          neverDiminishing: true,
          obsolete: true,
          barcode: undefined,
          applicationType: [],
          unitPrice: undefined,
          laborPrice: undefined,
          manufacturer: undefined,
          vendor: undefined,
          dimensions: { diameter: undefined, maxLength: undefined }
        },
        {
          clientRef: "MFOA20004",
          vendorRef: "MFOA20004",
          description: "72 FO G.657A2 conduite modulo 6",
          familyID: "ca",
          quantity: 2450,
          unit: "m",
          neverDiminishing: true,
          obsolete: false,
          barcode: undefined,
          applicationType: [],
          unitPrice: undefined,
          laborPrice: undefined,
          manufacturer: undefined,
          vendor: undefined,
          dimensions: { diameter: undefined, maxLength: undefined }
        }
      ];
      importedCables.forEach(cable => commit("CREATE_NEW_MATERIAL", cable));
    } else if (data.file.includes("closure")) {
      let importedClosures = [
        {
          clientRef: "MFOA20147",
          vendorRef: "MFOA20147",
          description: "Tiroir 144 charniÃ¨re droite pour NRO Pti",
          familyID: "cl",
          quantity: 120,
          unit: "un",
          neverDiminishing: true,
          obsolete: false,
          barcode: undefined,
          applicationType: [],
          unitPrice: undefined,
          laborPrice: undefined,
          manufacturer: undefined,
          vendor: undefined,
          dimensions: { height: undefined, width: undefined, length: undefined }
        },
        {
          clientRef: "MFOA20179",
          vendorRef: "MFOA20179",
          description: "Armoire PM300-2x28U (ivoire_clair_RAL 1015)",
          familyID: "cl",
          quantity: 5,
          unit: "un",
          neverDiminishing: true,
          obsolete: true,
          barcode: undefined,
          applicationType: [],
          unitPrice: undefined,
          laborPrice: undefined,
          manufacturer: undefined,
          vendor: undefined,
          dimensions: { height: undefined, width: undefined, length: undefined }
        },
        {
          clientRef: "MFOA20181",
          vendorRef: "MFOA20181",
          description: "Armoire PM300-2x28U (vert_sapin_RAL 6009)",
          familyID: "cl",
          quantity: 250,
          unit: "un",
          neverDiminishing: true,
          obsolete: false,
          barcode: undefined,
          applicationType: [],
          unitPrice: undefined,
          laborPrice: undefined,
          manufacturer: undefined,
          vendor: undefined,
          dimensions: { height: undefined, width: undefined, length: undefined }
        },
        {
          clientRef: "MFOA20189",
          vendorRef: "MFOA20189",
          description: "Armoire PM300-2x28U (gris_bÃ©ton_RAL 7023)",
          familyID: "cl",
          quantity: 450,
          unit: "un",
          neverDiminishing: true,
          obsolete: false,
          barcode: undefined,
          applicationType: [],
          unitPrice: undefined,
          laborPrice: undefined,
          manufacturer: undefined,
          vendor: undefined,
          dimensions: { height: undefined, width: undefined, length: undefined }
        },
        {
          clientRef: "MFOA20184",
          vendorRef: "MFOA20184",
          description: "Armoire PM300-2x28U (gris_fer_RAL 7011)",
          familyID: "cl",
          quantity: 2,
          unit: "un",
          neverDiminishing: true,
          obsolete: true,
          barcode: undefined,
          applicationType: [],
          unitPrice: undefined,
          laborPrice: undefined,
          manufacturer: undefined,
          vendor: undefined,
          dimensions: { height: undefined, width: undefined, length: undefined }
        }
      ];
      importedClosures.forEach(closure =>
        commit("CREATE_NEW_MATERIAL", closure)
      );
    }
  },
  EXPORT_MATERIALS_REPORT({ commit }, data) {
    commit("EXPORT_MATERIALS_REPORT", data);
  },

  getHistory({commit}) {
    return new Promise((resolve, reject) => {
      API.materials.getHistory(
        result => {
          resolve(result.data.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default { state, getters, actions, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/Management/Stock/materials.js